import type { SensorePLCDTO } from '@/models/dto/plc/sensore-plc-dto'
import type { SensorConfiguration } from '@/models/types/plc/sensor-configuration'

const mapToSensorConfiguration = (dto: SensorePLCDTO): SensorConfiguration => {
    return {
        id: dto.id,
        group: dto.gruppo ?? undefined,
        position: dto.posizione ?? undefined,
        name: dto.aliasId ?? undefined,
        enabled: dto.abilitato,
        min: dto.fondoScalaMin,
        max: dto.fondoScalaMax,
        active: dto.attivo,
        uom: dto.um ?? undefined,
    }
}

export { mapToSensorConfiguration }
